export interface IWishlistItem {
  readonly product_id: string
  readonly color: string
  readonly website_light_product?: any
}

export enum ACTION {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export class WishListItem implements IWishlistItem {
  readonly product_id: string
  readonly color: string
  readonly website_light_product?: any // TODO: Update this after website light product is fully migrated to v2

  constructor({ product_id, color, website_light_product = {} }: IWishlistItem) {
    this.product_id = product_id
    this.color = color
    this.website_light_product = website_light_product
    return {
      ...this,
    }
  }

  static factEquals(wishListItem1: WishListItem, wishListItem2: WishListItem): boolean {
    return this.getWishListId(wishListItem1) === this.getWishListId(wishListItem2)
  }

  static getWishListId(wishListItem: WishListItem): string {
    return `${wishListItem.product_id}_${wishListItem.color}`
  }
}

export interface SharedWishlistRes {
  user_name?: string
  wishlist?: WishListItem[]
}
